export default __webpack_public_path__ + "static/media/why_bg.11d529f3.png";